import { createFileRoute, redirect } from '@tanstack/react-router';
import { OFFER_FRIENDS_ANCHOR } from '@/features/new-client-offer/setup/offer-setup-anchors';

/** Old Refer a Friend Setup → the friends card on New Client Offer › Setup. No side effects: hover preload runs it. */
export const Route = createFileRoute('/_auth/$orgId/marketing/referrals/setup')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/$orgId/marketing/new-client-offer/setup', params: { orgId: params.orgId }, hash: OFFER_FRIENDS_ANCHOR, replace: true });
  },
});
